import React, { useEffect, useState } from 'react'
import axios from 'axios'
import HouseView from '../components/HouseView'
import HouseDetails from '../components/HouseDetails'
import PersonDetails from '../components/PersonDetails'
import {
  Route,
} from 'react-router-dom'


function Home(props){

  const [houses, setHouses] = useState([])

  useEffect(()=>{
    axios.get('https://www.potterapi.com/v1/houses?key=$2a$10$ZDF7yaUXPhkdZHoIeg26H.phHi7ALfk7kfxFkUOoy8NROl1oMUPgi')
    .then(({data})=>{
      setHouses([...houses, ...data])
      console.log('===========', houses)
    })
  },[])

  return(
      <div className="row mx-auto">

          <div className="col-4">
            <HouseView houses={houses}></HouseView>
          </div>

          <div className="col-8">

            <Route exact path='/house/:id'>
              <HouseDetails/>
            </Route>
            
            <Route exact path='/person/:id'>
              <PersonDetails/>
            </Route>

          </div>
      </div>
  )
}

export default Home